/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
/* eslint-disable react/no-danger */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-console */
import React, { forwardRef, useImperativeHandle, useState } from 'react';
import { Link } from 'react-router-dom';
import { DialogUtility, DialogComponent } from '@syncfusion/ej2-react-popups';
import { createSpinner, showSpinner, hideSpinner } from '@syncfusion/ej2-popups';
import { format, parseISO } from 'date-fns';
import {
  CircularGaugeComponent,
  AxesDirective,
  AxisDirective,
  PointersDirective,
  PointerDirective,
} from '@syncfusion/ej2-react-circulargauge';
import { ChartComponent, SeriesCollectionDirective, SeriesDirective, Inject as ChartInject, Legend, DateTime, Tooltip as ChartTooltip, LineSeries, Zoom } from '@syncfusion/ej2-react-charts';
import { useStateContext } from '../contexts/ContextProvider';
// eslint-disable-next-line import/no-cycle
import AssociateView from './AssociateView';
import { GMap, UserFAQ } from '.';
import '../pages/Zackat.css';

const riskBandColors = (risk) => {
  const none = {
    hypo: 'transparent',
    base: 'transparent',
    moderate: 'transparent',
    elevated: 'transparent',
    severe: 'transparent',
  };
  if (risk < 0) return { ...none, hypo: 'cyan' };
  if (risk === '' || risk === undefined || risk === null || risk < 25) return { ...none, base: 'cyan' };
  if (risk < 50) return { ...none, moderate: 'cyan' };
  if (risk < 80) return { ...none, elevated: 'cyan' };
  return { ...none, severe: 'cyan' };
};

const calculateAge = (dob) => {
  if (!dob) return '';
  const today = new Date();
  const birthDateObj = new Date(dob);
  let calculatedAge = today.getFullYear() - birthDateObj.getFullYear();
  const monthDiff = today.getMonth() - birthDateObj.getMonth();
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDateObj.getDate())) {
    calculatedAge -= 1;
  }
  return calculatedAge;
};

const formatPhoneNumber = (phoneNumberString) => {
  if (!phoneNumberString || phoneNumberString.length <= 0) return null;
  let phone = phoneNumberString;
  if (phone.length === 10) phone = `1${phone}`;
  const cleaned = (`${phone}`).replace(/\D/g, '');
  const match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    const intlCode = (match[1] ? '+1 ' : '');
    return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
  }
  return null;
};

const vitalStampStyle = (timestamp) => {
  if (!timestamp) return { color: 'red' };
  const t = parseISO(timestamp);
  const stale = Number.isNaN(t.getTime()) || (Date.now() - t.getTime() > 8 * 60 * 60 * 1000);
  return stale ? { color: '#F6821E' } : { color: 'green', fontWeight: 'bold' };
};

const trendXAxis = (primary, peer) => {
  const times = [...(primary || []), ...(peer || [])]
    .map((p) => (p && p.time ? new Date(p.time).getTime() : NaN))
    .filter((n) => !Number.isNaN(n));
  const axis = {
    valueType: 'DateTime',
    labelIntersectAction: 'Rotate45',
    rangePadding: 'None',
    plotOffset: 0,
    edgeLabelPlacement: 'Shift',
    majorGridLines: { width: 0 },
  };
  if (times.length) {
    axis.minimum = new Date(Math.min(...times));
    axis.maximum = new Date(Math.max(...times));
  }
  return axis;
};

const sizeTrendChart = (args) => {
  const { chart } = args;
  if (!chart || !chart.element) return;
  const { parentElement: parent } = chart.element;
  if (!parent) return;
  const { clientWidth: targetW } = parent;
  if (!(targetW > 50)) return;
  if (chart.fittedWidth === targetW) return;
  chart.fittedWidth = targetW;
  chart.width = `${targetW}px`;
  chart.refresh();
};

const refreshTrendCharts = () => {
  ['trend-hr-chart', 'trend-tmp-chart'].forEach((id) => {
    const el = document.getElementById(id);
    const chart = el && el.ej2_instances && el.ej2_instances[0];
    if (chart && typeof chart.refresh === 'function') {
      chart.fittedWidth = undefined;
      const { parentElement: parent } = el;
      chart.width = parent && parent.clientWidth ? `${parent.clientWidth}px` : '100%';
      chart.refresh();
    }
  });
};

const AssociateActionDialogs = forwardRef((props, ref) => {
  const { isMobile, setAIType } = useStateContext();
  const { REACT_APP_API_ENDPOINT } = process.env;
  const [viewVisible, setViewVisible] = useState(false);
  const [trendVisible, setTrendVisible] = useState(false);
  const [dialogAssociate, setDialogAssociate] = useState(null);
  const [trendData, setTrendData] = useState({
    answer: '',
    name: 'Associate',
    hr: [],
    avgHr: [],
    tmp: [],
    avgTmp: [],
  });

  const boxPad = isMobile ? '16px' : '24px';
  const boxFont = isMobile ? '1rem' : '1.25rem';
  const containerStyle = {
    display: 'grid',
    gridTemplateColumns: isMobile ? '1fr' : 'repeat(2, 1fr)',
    gap: isMobile ? '12px' : '16px',
    padding: isMobile ? '12px' : '16px',
  };
  const lboxStyle = {
    backgroundColor: '#F6821E7f',
    color: 'black',
    padding: boxPad,
    textAlign: 'left',
    borderRadius: '8px',
    fontSize: boxFont,
    minWidth: 0,
  };
  const lgboxStyle = {
    backgroundColor: '#78DA897f',
    color: 'black',
    padding: boxPad,
    textAlign: 'left',
    borderRadius: '8px',
    fontSize: boxFont,
    minWidth: 0,
  };
  const linkStyle = {
    margin: '1rem',
    textDecoration: 'underline',
    color: 'blue',
  };

  const startTrendSpinner = () => {
    setAIType('Predictive Analysis');
    const target = document.getElementById('trend-activity-indicator');
    if (!target) return;
    if (!target.querySelector('.e-spinner-pane')) {
      createSpinner({ target, label: 'Retrieving analysis...', cssClass: 'trend-spinner' });
    }
    target.style.pointerEvents = 'auto';
    target.style.backgroundColor = '#78DA897f';
    showSpinner(target);
  };
  const stopTrendSpinner = () => {
    const target = document.getElementById('trend-activity-indicator');
    if (!target) return;
    hideSpinner(target);
    target.style.pointerEvents = 'none';
    target.style.backgroundColor = 'transparent';
  };

  const onPromptRequest = async (row) => {
    startTrendSpinner();
    try {
      if (!row || !row._id) {
        DialogUtility.alert('Please enter a prompt and try again.');
        return;
      }
      let usr = localStorage.getItem('user');
      usr = usr ? JSON.parse(usr) : null;
      if (!usr) {
        DialogUtility.alert('Please login and try again.');
        return;
      }
      const userPrompt = "Show trends and comparisons of the associate's data.";
      const query = Object.entries(usr)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');
      const uri = `${REACT_APP_API_ENDPOINT}/faq?${query}`;
      const payload = { question: userPrompt, kbid: 'Predictive Analysis', patientid: row._id };
      const response = await fetch(uri, {
        method: 'PUT',
        body: JSON.stringify(payload),
        headers: {
          'Content-Type': 'application/json',
          Authorization: `JWTToken ${usr.token}`,
        },
      });
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const mydata = await response.json()
        .catch((err) => {
          console.error('Error parsing JSON:', err);
          return null;
        });
      const src = (mydata && (mydata.hr || mydata.avg_hr || mydata.tmp || mydata.avg_tmp))
        ? mydata
        : (mydata && mydata.answer && typeof mydata.answer === 'object' ? mydata.answer : mydata) || {};
      const trendHtml = (typeof src.answer === 'string' && src.answer)
        || (mydata && typeof mydata.answer === 'string' ? mydata.answer : '');
      const toTime = (epoch, fallback) => {
        if (epoch != null && epoch !== '') {
          const n = Number(epoch);
          if (!Number.isNaN(n)) return new Date(n > 1e12 ? n : n * 1000);
        }
        if (fallback) return new Date(fallback);
        return null;
      };
      const rowToPoint = (point, header) => {
        if (!point) return null;
        if (Array.isArray(point) && Array.isArray(header)) {
          const obj = {};
          header.forEach((key, i) => { obj[key] = point[i]; });
          return obj;
        }
        if (typeof point === 'object') return point;
        return null;
      };
      const flattenVitals = (series) => {
        if (!series) return [];
        const docs = Array.isArray(series) ? series : [series];
        const points = [];
        docs.forEach((doc) => {
          if (!doc || typeof doc !== 'object') return;
          const nested = doc.vitals || doc.data || doc.samples || doc.readings;
          if (Array.isArray(nested) && nested.length) {
            nested.forEach((nestedRow) => {
              const p = rowToPoint(nestedRow, doc.header);
              if (p) points.push(p);
            });
            return;
          }
          if (doc.epoch != null || doc.value != null) points.push(doc);
        });
        return points;
      };
      const mapVitals = (list) => flattenVitals(list)
        .map((p) => {
          const time = toTime(p.epoch, p.timestamp || p.hour);
          const value = p.value != null ? Number(p.value) : NaN;
          if (!time || Number.isNaN(time.getTime()) || Number.isNaN(value)) return null;
          return { time, value };
        })
        .filter(Boolean)
        .sort((a, b) => a.time - b.time);
      const mapAverages = (list) => (Array.isArray(list) ? list : [])
        .filter((p) => p && p.hour && p.avg_value != null)
        .map((p) => ({ time: new Date(p.hour), value: Number(p.avg_value) }))
        .sort((a, b) => a.time - b.time);
      setTrendData({
        answer: trendHtml,
        name: src.name || (row && row.name) || 'Associate',
        hr: mapVitals(src.hr),
        avgHr: mapAverages(src.avg_hr),
        tmp: mapVitals(src.tmp),
        avgTmp: mapAverages(src.avg_tmp),
      });
      setTrendVisible(true);
    } catch (error) {
      console.error('Error fetching data:', error);
      DialogUtility.alert(`Sorry, something went wrong. Please try again. ${error.message}`);
    } finally {
      stopTrendSpinner();
    }
  };

  useImperativeHandle(ref, () => ({
    openView: (row) => {
      setDialogAssociate(row);
      setViewVisible(true);
    },
    openTrends: (row) => {
      setDialogAssociate(row);
      onPromptRequest(row);
    },
  }));

  const associate = dialogAssociate || {};
  const bands = riskBandColors(associate.risk);
  const riskPercentage = parseInt(associate.risk && associate.risk !== '' ? associate.risk : 5, 10);
  const exercisePercentage = parseInt(associate.activity && associate.activity.reading !== '' ? ((associate.activity.reading / 5000) * 100).toFixed(0) : 5, 10);
  const envPercentage = parseInt(associate.environment && associate.environment !== '' ? associate.environment : 5, 10);
  const legendItems = [
    { label: 'Risk', color: '#fa114f', value: `${riskPercentage}%` },
    { label: 'Activity', color: '#00ff66', value: `${exercisePercentage}%` },
    { label: 'Environment', color: '#00f0ff', value: `${envPercentage}°` },
  ];

  const panel2Content = () => (
    <div
      className="zackat-divalh"
      style={{
        display: 'block',
        width: '100%',
        maxWidth: '100%',
        boxSizing: 'border-box',
        overflowY: 'auto',
        textAlign: 'center',
      }}
    >
      <span style={{ display: 'block', textAlign: 'center' }}> BIOMETRICS</span>
      <table
        className="biotable"
        style={{ display: 'table', width: '100%', minWidth: '100%', tableLayout: 'fixed', boxSizing: 'border-box' }}
      >
        <tbody>
          <tr>
            <th style={{ backgroundColor: bands.hypo, padding: '0.5rem', width: '20%', textAlign: 'center' }}>
              <font color="blue">HYPO</font>
            </th>
            <th style={{ backgroundColor: bands.base, width: '20%', padding: '0.5rem', textAlign: 'center' }}>
              <font color="green">BASELINE</font>
            </th>
            <th style={{ backgroundColor: bands.moderate, width: '20%', padding: '0.5rem', textAlign: 'center' }}>
              <font color="yellow">MODERATE</font>
            </th>
            <th style={{ backgroundColor: bands.elevated, width: '20%', padding: '0.5rem', textAlign: 'center' }}>
              <font color="orange">ELEVATED</font>
            </th>
            <th style={{ backgroundColor: bands.severe, width: '20%', padding: '0.5rem', textAlign: 'center' }}>
              <font color="red">SEVERE</font>
            </th>
          </tr>
        </tbody>
      </table>
      {(associate && associate.hipaa && associate.hipaa.consent && associate.hipaa.consent === true) || !associate.hipaa
        ? (
          <table className="biotable1" style={{ display: 'table', width: '100%', minWidth: '100%', tableLayout: 'fixed', boxSizing: 'border-box' }}>
            <tbody>
              <tr>
                <th colSpan={2} style={{ backgroundColor: 'white' }}>Risk Level {associate.risk}</th>
              </tr>
              <tr>
                <td className={associate.heartrate && associate.heartrate.alert && associate.heartrate.alert.length > 0 ? 'biometricsred flash-animation' : 'biometricsgrn'}>
                  <sup className="supsm">hr</sup>
                  💖{associate.heartrate && associate.heartrate.reading ? associate.heartrate.reading : ''}
                  <sub className="supsm">bpm</sub>
                  <sup className="supsm">
                    ({associate.baseline && associate.baseline.heartrate && associate.baseline.heartrate.nominal ? associate.baseline.heartrate.nominal.toFixed(1) : ''})
                  </sup>
                </td>
                <td className={associate.hrv && associate.hrv.alert && associate.hrv.alert.length > 0 ? 'biometricsred flash-animation' : 'biometricsltgrn'}>
                  <sup className="supsm">hrv</sup>
                  💗{associate.hrv && associate.hrv.reading ? associate.hrv.reading : ''}
                  <sub className="supsm">ms</sub>
                  <sup className="supsm">
                    ({associate.baseline && associate.baseline.hrv && associate.baseline.hrv.nominal ? associate.baseline.hrv.nominal.toFixed(1) : ''})
                  </sup>
                </td>
              </tr>
              <tr>
                <td className={associate.oxygen && associate.oxygen.alert && associate.oxygen.alert.length > 0 ? 'biometricsred flash-animation' : 'biometricsorn'}>
                  <sup className="supsm">oxy</sup>
                  <span className="biometricsltblue">O<sub>2</sub></span>
                  {associate.oxygen && associate.oxygen.reading ? associate.oxygen.reading : ''}
                  <sub className="supsm">%</sub>
                  <sup className="supsm">
                    ({associate.baseline && associate.baseline.oxygen && associate.baseline.oxygen.nominal ? associate.baseline.oxygen.nominal.toFixed(1) : ''})
                  </sup>
                </td>
                <td className={associate.temperature && associate.temperature.alert && associate.temperature.alert.length > 0 ? 'biometricsred flash-animation' : 'biometricsylw'}>
                  <sup className="supsm">temp</sup>
                  <span className="rotate-char">🌡</span>{associate.temperature && associate.temperature.reading ? associate.temperature.reading : ''}
                  <sub className="supsm">°F</sub>
                  <sup className="supsm">
                    ({associate.baseline && associate.baseline.temperature && associate.baseline.temperature.nominal ? associate.baseline.temperature.nominal.toFixed(1) : ''})
                  </sup>
                </td>
              </tr>
              <tr>
                <td className={associate.hydration && associate.hydration.alert && associate.hydration.alert.length > 0 ? 'biometricsred flash-animation' : 'biometricsblue'}>
                  <sup className="supsm">hyd</sup>
                  💦{associate.hydration && associate.hydration.reading ? associate.hydration.reading : ''}
                  <sub className="supsm">%</sub>
                  <sup className="supsm">
                    ({associate.baseline && associate.baseline.hydration && associate.baseline.hydration.nominal ? associate.baseline.hydration.nominal.toFixed(1) : ''})
                  </sup>
                </td>
                <td className={associate.respiratory && associate.respiratory.alert && associate.respiratory.alert.length > 0 ? 'biometricsred flash-animation' : 'biometricsblue'}>
                  <sup className="supsm">rr</sup>
                  🫁{associate.respiratory && associate.respiratory.reading ? associate.respiratory.reading : ''}<sub className="supsm">b/m</sub>
                  <sup className="supsm">
                    ({associate.baseline && associate.baseline.respiratory && associate.baseline.respiratory.nominal ? associate.baseline.respiratory.nominal.toFixed(1) : ''})
                  </sup>
                </td>
              </tr>
            </tbody>
          </table>
        )
        : (
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'top',
            height: 'auto',
          }}
          >
            <div>Risk Level {associate.risk}<br />
              <div>███</div>
            </div>
          </div>
        )}
    </div>
  );

  const viewTemplate = () => (
    dialogAssociate ? <AssociateView currentAssociate={dialogAssociate} /> : <div />
  );

  const trendTemplate = () => (
    <div style={{ padding: '12px', overflowY: 'auto', height: '100%' }}>
      <div style={containerStyle}>
        <div
          style={lboxStyle}
          dangerouslySetInnerHTML={{ __html: (trendData && trendData.answer) ? `<h1> ❖ Associate ${associate.name} Predictive Trend Analysis</h1><br>${trendData.answer}<br />` : 'No trend data returned.' }}
        />
        <div style={containerStyle}>
          <div style={{
            backgroundColor: '#0000001f',
            padding: '2px',
            borderRadius: '4px',
            width: '100%',
            height: '100%',
            textAlign: 'center',
            display: 'flex',
            flexDirection: 'column',
          }}
          >
            <Link
              to="/associatelayout"
              style={linkStyle}
              onClick={() => { localStorage.setItem('currentAssociate', associate.name); }}
            >{associate.name}
            </Link>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <div style={{ width: 240, height: 240, pointerEvents: 'none' }}>
                <CircularGaugeComponent
                  id="worker-status-gauge"
                  key={associate._id}
                  background="transparent"
                  width="240px"
                  height="240px"
                  enableRtl={false}
                  enablePointerDrag={false}
                  tooltip={{ enable: false }}
                >
                  <AxesDirective>
                    <AxisDirective
                      startAngle={0}
                      endAngle={360}
                      minimum={0}
                      maximum={100}
                      lineStyle={{ width: 0 }}
                      majorTicks={{ width: 0 }}
                      minorTicks={{ width: 0 }}
                      labelStyle={{ font: { size: '0px' } }}
                    >
                      <PointersDirective>
                        <PointerDirective value={100} type="RangeBar" radius="100%" color="rgba(255, 0, 51, 0.15)" pointerWidth={16} />
                        <PointerDirective value={riskPercentage} type="RangeBar" radius="100%" color="#fa114f" pointerWidth={16} roundedCornerRadius={8} animation={{ enable: true, duration: 1000 }} />
                        <PointerDirective value={100} type="RangeBar" radius="82%" color="rgba(0, 255, 102, 0.15)" pointerWidth={16} />
                        <PointerDirective value={riskPercentage} type="RangeBar" radius="82%" color="#00ff66" pointerWidth={16} roundedCornerRadius={8} animation={{ enable: true, duration: 1200 }} />
                        <PointerDirective value={100} type="RangeBar" radius="64%" color="rgba(0, 240, 255, 0.15)" pointerWidth={16} />
                        <PointerDirective value={envPercentage} type="RangeBar" radius="64%" color="#00f0ff" pointerWidth={16} roundedCornerRadius={8} animation={{ enable: true, duration: 1400 }} />
                      </PointersDirective>
                    </AxisDirective>
                  </AxesDirective>
                </CircularGaugeComponent>
              </div>
            </div>
            <div style={{
              display: 'flex',
              justifyContent: 'space-around',
              marginTop: '16px',
              borderTop: '1px solid #222',
              paddingTop: '16px',
            }}
            >
              {legendItems.map((item) => (
                <div key={item.label} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <span style={{
                    width: '10px',
                    height: '10px',
                    borderRadius: '50%',
                    backgroundColor: item.color,
                    display: 'inline-block',
                  }}
                  />
                  <div style={{ display: 'flex', flexDirection: 'column', lineHeight: '1.2' }}>
                    <span style={{ color: item.color, fontWeight: 'bold', fontSize: '12px' }}>{item.label}</span>
                    <span style={{ color: '#ffffff', fontSize: '15px', fontWeight: 'bold' }}>{item.value}</span>
                  </div>
                </div>
              ))}
            </div>
            <div style={{ width: '100%', maxWidth: '100%', boxSizing: 'border-box' }}>
              {panel2Content()}
            </div>
            <div className="my-10" style={{ textAlign: 'left' }}>
              {associate.temperature && associate.temperature.reading ? <p style={vitalStampStyle(associate.temperature.timestamp)}>Core Body Temperature: {associate.temperature.reading} °F {associate.temperature.timestamp ? `${format(parseISO(associate.temperature.timestamp), 'MM/dd/yy p')}` : ''} </p> : <p>Core Body Temperature: N/A</p>}
              {associate.heartrate && associate.heartrate.reading ? <p style={vitalStampStyle(associate.heartrate.timestamp)}>Heart Rate: {associate.heartrate.reading} bpm {associate.heartrate.timestamp ? `${format(parseISO(associate.heartrate.timestamp), 'MM/dd/yy p')}` : ''} </p> : <p>Heart Rate: N/A</p>}
              {associate.hrv && associate.hrv.reading ? <p style={vitalStampStyle(associate.hrv.timestamp)}>HRV: {associate.hrv.reading} ms {associate.hrv.timestamp ? `${format(parseISO(associate.hrv.timestamp), 'MM/dd/yy p')}` : ''} </p> : <p>HRV: N/A</p>}
              {associate.oxygen && associate.oxygen.reading ? <p style={vitalStampStyle(associate.oxygen.timestamp)}>Oxygen: {associate.oxygen.reading} % {associate.oxygen.timestamp ? `${format(parseISO(associate.oxygen.timestamp), 'MM/dd/yy p')}` : ''} </p> : <p>Oxygen: N/A</p>}
              {associate.hydration && associate.hydration.reading ? <p style={vitalStampStyle(associate.hydration.timestamp)}>Hydration: {associate.hydration.reading} % {associate.hydration.timestamp ? `${format(parseISO(associate.hydration.timestamp), 'MM/dd/yy p')}` : ''} </p> : <p>Hydration: N/A</p>}
              {associate.respiratory && associate.respiratory.reading ? <p style={vitalStampStyle(associate.respiratory.timestamp)}>Respiratory: {associate.respiratory.reading} b/pm {associate.respiratory.timestamp ? `${format(parseISO(associate.respiratory.timestamp), 'MM/dd/yy p')}` : ''} </p> : <p>Respiratory: N/A</p>}
              {associate.activity && associate.activity.reading ? <p style={vitalStampStyle(associate.activity.timestamp)}>Activity: {associate.activity.reading} steps {associate.activity.timestamp ? `${format(parseISO(associate.activity.timestamp), 'MM/dd/yy p')}` : ''} </p> : <p>Activity: N/A</p>}
            </div>
            <div style={{ width: '100%', marginTop: 'auto' }}>
              <UserFAQ dt="Associate Analysis" />
            </div>
          </div>
          <div
            style={{
              ...lgboxStyle,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'stretch',
              gap: isMobile ? '12px' : '16px',
            }}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'flex-start',
                gap: isMobile ? '12px' : '16px',
                width: '100%',
              }}
            >
              {associate.employeeImage
                ? <img src={associate.employeeImage} alt="" style={{ width: '100px', height: '100px', borderRadius: '50%', flexShrink: 0 }} />
                : <p style={{ margin: 0, flexShrink: 0, width: '100px' }}>No Image Available</p>}
              <div style={{ minWidth: 0, flex: 1 }}>
                {associate.dob ? <p>Date of Birth: {calculateAge(associate.dob)} years old</p> : <p>Date of Birth: N/A</p>}
                {associate.gender ? <p>Gender: {associate.gender.toUpperCase()} </p> : <p>Gender: N/A</p>}
                {associate.height ? <p>Height: {associate.height} </p> : <p>Height: N/A</p>}
                {associate.weight ? <p>Weight: {associate.weight} </p> : <p>Weight: N/A</p>}
                {associate.height && associate.weight ? <p>BMI: {((associate.weight / (associate.height * associate.height)) * 703).toFixed(1) } </p> : <p>BMI: N/A</p>}
                {associate.mobile ? <p>Mobile: {formatPhoneNumber(associate.mobile)} </p> : <p>Mobile: N/A</p>}
                {associate.email ? <p>EMAIL: {associate.email.toLowerCase()} </p> : <p>EMAIL: N/A</p>}
                {associate.timestamp ? (
                  <p>Last Reported: {parseISO(associate.timestamp).toLocaleString('en-US', {
                    month: '2-digit',
                    day: '2-digit',
                    hour: '2-digit',
                    minute: '2-digit',
                    hour12: true,
                  })}
                  </p>
                ) : <p>Last Reported: N/A</p>}
              </div>
            </div>
            <div style={{ width: '100%' }}>
              <GMap props={associate} days={1} />
            </div>
          </div>
        </div>
      </div>
      <div style={containerStyle}>
        <div style={{ ...lgboxStyle, width: '100%', minWidth: 0 }}>
          <ChartComponent
            id="trend-hr-chart"
            className="syncfusion-chart trend-fill-chart"
            width="100%"
            height="320px"
            title="Heart Rate"
            loaded={sizeTrendChart}
            chartArea={{ border: { width: 0 }, width: '100%' }}
            margin={{ left: 8, right: 8, top: 8, bottom: 8 }}
            primaryXAxis={trendXAxis(trendData.hr, trendData.avgHr)}
            primaryYAxis={{ title: 'BPM', rangePadding: 'None' }}
            tooltip={{ enable: true }}
            legendSettings={{ visible: true, position: 'Top' }}
            zoomSettings={{
              enableSelectionZooming: true,
              enableMouseWheelZooming: true,
              enablePinchZooming: true,
              enablePan: true,
              showToolbar: true,
            }}
            style={{ width: '100%', display: 'block' }}
          >
            <ChartInject services={[LineSeries, Legend, ChartTooltip, DateTime, Zoom]} />
            <SeriesCollectionDirective>
              <SeriesDirective name={trendData.name || 'Associate'} dataSource={trendData.hr || []} xName="time" yName="value" type="Line" fill="darkgreen" width={2} />
              <SeriesDirective name="Peer Average" dataSource={trendData.avgHr || []} xName="time" yName="value" type="Line" fill="gray" width={2} />
            </SeriesCollectionDirective>
          </ChartComponent>
        </div>
        <div style={{ ...lboxStyle, width: '100%', minWidth: 0 }}>
          <ChartComponent
            id="trend-tmp-chart"
            className="syncfusion-chart trend-fill-chart"
            width="100%"
            height="320px"
            title="Core Body Temperature"
            loaded={sizeTrendChart}
            chartArea={{ border: { width: 0 }, width: '100%' }}
            margin={{ left: 8, right: 8, top: 8, bottom: 8 }}
            primaryXAxis={trendXAxis(trendData.tmp, trendData.avgTmp)}
            primaryYAxis={{ title: '°F', rangePadding: 'None' }}
            tooltip={{ enable: true }}
            legendSettings={{ visible: true, position: 'Top' }}
            zoomSettings={{
              enableSelectionZooming: true,
              enableMouseWheelZooming: true,
              enablePinchZooming: true,
              enablePan: true,
              showToolbar: true,
            }}
            style={{ width: '100%', display: 'block' }}
          >
            <ChartInject services={[LineSeries, Legend, ChartTooltip, DateTime, Zoom]} />
            <SeriesCollectionDirective>
              <SeriesDirective name={trendData.name || 'Associate'} dataSource={trendData.tmp || []} xName="time" yName="value" type="Line" fill="orange" width={2} />
              <SeriesDirective name="Peer Average" dataSource={trendData.avgTmp || []} xName="time" yName="value" type="Line" fill="gray" width={2} />
            </SeriesCollectionDirective>
          </ChartComponent>
        </div>
      </div>
    </div>
  );

  const viewbuttons = [
    {
      click: () => { setViewVisible(false); },
      buttonModel: { isPrimary: true, content: 'OK' },
    },
  ];
  const trendbuttons = [
    {
      click: () => { setTrendVisible(false); },
      buttonModel: { isPrimary: true, content: 'OK' },
    },
  ];

  return (
    <>
      <div
        id="trend-activity-indicator"
        style={{
          position: 'fixed',
          inset: 0,
          zIndex: 100000,
          pointerEvents: 'none',
        }}
      />
      {viewVisible && (
        <DialogComponent
          header={(dialogAssociate && dialogAssociate.name) || 'Associate'}
          content={viewTemplate}
          buttons={viewbuttons}
          width="100%"
          height="100%"
          isModal
          visible
          closeOnEscape
          showCloseIcon
          onClose={() => { setViewVisible(false); }}
          close={() => { setViewVisible(false); }}
        />
      )}
      {trendVisible && (
        <DialogComponent
          header="Trends"
          content={trendTemplate}
          buttons={trendbuttons}
          width="100%"
          height="100%"
          isModal
          visible
          closeOnEscape
          showCloseIcon
          open={() => { setTimeout(refreshTrendCharts, 200); }}
          close={() => { setTrendVisible(false); }}
        />
      )}
    </>
  );
});

AssociateActionDialogs.displayName = 'AssociateActionDialogs';

export default AssociateActionDialogs;
